var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14.022,
    viewBox: "0 0 22 14.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(0 -92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163317",
    "data-name": "Group 163317",
    transform: "translate(0 92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163316",
    "data-name": "Group 163316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24953",
    "data-name": "Path 24953",
    d: "M21.86,99.418c-.2-.269-4.879-6.583-10.86-6.583S.336,99.149.14,99.418a.726.726,0,0,0,0,.856c.2.269,4.879,6.583,10.86,6.583s10.664-6.314,10.86-6.583A.725.725,0,0,0,21.86,99.418ZM11,105.406c-4.406,0-8.221-4.191-9.351-5.561,1.128-1.371,4.936-5.56,9.351-5.56s8.221,4.19,9.351,5.561C19.223,101.218,15.415,105.406,11,105.406Z",
    transform: "translate(0 -92.835)",
    fill: ""
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_163319",
    "data-name": "Group 163319",
    transform: "translate(6.648 95.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163318",
    "data-name": "Group 163318",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24954",
    "data-name": "Path 24954",
    d: "M159.074,154.725a4.352,4.352,0,1,0,4.352,4.352A4.357,4.357,0,0,0,159.074,154.725Zm0,7.253a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,159.074,161.978Z",
    transform: "translate(-154.722 -154.725)",
    fill: ""
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActions);
export default __webpack_public_path__ + "static/media/actions.937cd6886eb15b26fea716460f5c71e0.svg";
export { ForwardRef as ReactComponent };